module.exports = __webpack_public_path__ + "img/radio.64dc13ba.svg";